export default __webpack_public_path__ + "static/media/arrow-left.121ad6f2.svg";